import '@popperjs/core';
import 'bootstrap';
import 'htmx.org';
import 'tom-select';
import './netbox';
